// extracted by mini-css-extract-plugin
module.exports = {"authors":"Authors_authors_3SAqi","m_authors":"Authors_m_authors_3Q3iD","list":"Authors_list_2t-S7","item":"Authors_item_2mI5-"};